if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: false,
      numberFilterTree: 2,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;

    var hiddentags = (data.tags.indexOf('hidden') != '-1') ? 'hidden' : '' ;
    
    itemHtml = itemHtml.replace(/{{hiddenClasses}}/g, hiddentags);
    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    itemHtml = itemHtml.replace(/{{itemfirstvariant}}/g, data.variants[0].id);
    itemHtml = itemHtml.replace(/{{itemVariantId}}/g, data.variants[0].id); 
    
    //-----------------------
    // Add Images
    //itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      // Add Images

    var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;
      //var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '500x') : boostPFSFilterConfig.general.no_image_url;
    var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(data.variants[0].image, '500x') : boostPFSFilterConfig.general.no_image_url;
      var activeSwapImage = !Utils.isMobile() && images.length > 1 && boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') && boostPFSThemeConfig.custom.show_secondary_image == true;
        var dataSrcSet = '', imgAlt = data.title, flipImageSrcSet = '', itemFlipImageHtml = '';
        for (var i = 0; i < rangeWidths.length; i++) {
          dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
  
          if (activeSwapImage) {
            flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
          }
  
          if (i < rangeWidths.length - 1) {
            dataSrcSet += ', ';
  
            if (activeSwapImage) {
              flipImageSrcSet += ', ';
            }
          }
        }
    if (activeSwapImage) {
      itemFlipImageHtml += '<div class="hidden">';
      itemFlipImageHtml += '<img src="' + flipImageSrcSet + '" alt="{{itemTitle}}" />';
      itemFlipImageHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImageHtml);
    // Add Labels
    var itemLabelsHtml = '';
    if (!soldOut) {
      var newLabel = data.collections.filter(function(e) { 
        
        return e.handle == 'new'; 
      });
      if (typeof newLabel[0] !== 'undefined') {
        itemLabelsHtml += '<div class="new icn">' + boostPFSConfig.label.new + '</div>';
      }
      if (onSale) {
        itemLabelsHtml += '<div class="sale-item icn">' + boostPFSConfig.label.sale + '</div>';
      }
    } else {
      itemLabelsHtml += '<div class="so icn">' + boostPFSConfig.label.sold_out + '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);
    //-------------------------
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    //AddColorSwatches
    itemHtml = itemHtml.replace(/{{itemColorSwatches}}/g, buildColorSwatches(data));
    //Add To Cart
    itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, buildAddToCart(data));
  
    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };


  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildImages(data) {
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media">';
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }
      
      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect"><img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce"' +
        'loading="lazy"' +
        'srcset="' + flipImageSrcSet + '" ' +
        'height="' + images[1].height + '" ' +
        'width="' + images[1].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount) : priceAmount;
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular">
                ${moneyPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular">
                  ${compareAtPrice}
                </s>
              </span>
              <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
              <span class="price-item price-item--sale price-item--last">
                ${moneyPrice}
              </span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`
    return html;
  }

 function buildAddToCart(data) {
  try {
        if (typeof iWish !== "undefined") {
        iWish.checkIwishColl();
        }
        } catch (error) {
        // console.log(error);
        }  
    var html = '';
    // if(data.metafields.length > 0) {
   
    // // Loop through metafields or use data directly if needed
    //   const handle = data.handle || 'example-product-handle'; // Replace or get from metafield if dynamic
  
    //   try {
    //     // 🟢 Connect to product JSON endpoint and wait for the response
    //     const response = await fetch(`/products/${handle}?variant=${data.selected_or_first_available_variant.id}`);
    //     const productData = await response.json();
  
    //     // Do something with productData here (e.g., check variants, inventory, etc.)
    //     console.log("Fetched product data:", productData);
  
    //     // You can now continue building your HTML or logic using productData
    //   } catch (error) {
    //     console.error("Error fetching product data:", error);
    //   }
    
    // }
    // var dependent = (data.tags.indexOf('dependent') != '-1') ? 'dependent' : '' ;
    var metafieldExist = "";
    if(data.metafields.length > 0) {
      metafieldExist = "metafield_exist";
    }

    html = `<form method="post" enctype="multipart/form-data" class="product-form ${metafieldExist}" data-handle="${data.handle}" id="AddToCartForm-${data.id}">`;
          html += `<div class="ig-submit-message hidden"> 
                  <input type="button" class="ig-submit-close" value="X">
                  <p class="ig-submit-success hidden">
                     <i class="fa fa-check"></i> Added to Cart <a href="/cart" class="tdf_cart_icon" tbinded="1">View Cart</a> or <a href="/collections/all">Continue Shopping</a>   
                  </p>
                  <p class="ig-submit-error">Only 59 quantity available</p> 
                </div>`
             if( data.available ) {
           html +=   `<div class="tooltip">
                <span class="tooltiptext">Qty</span>
                <input min="1" type="number" id="quantity" name="quantity" value="1"/>
              </div>
              <div class="product-variants"></div>
                <input  type="hidden" id="${data.variants[0].id}" name="id" data-sku="" value="${data.variants[0].id}" />
                    <div class="tooltip  wishlist-button">
                        <a class="iWishAddColl iwishcheck" href="#" data-variant="${data.variants[0].id}" data-product="${data.id}" data-pTitle="${data.title}"></a> 
                    </div>`;
             } 
              html +=   `<div class="tooltip">
                  <span class="tooltiptext">`;
                  if( data.available ) {
                   html += `Add to cart`;          
                 } else {
                   html += `Sold Out`;
                 } 
             html +=   `</span>
                   <button
                    id="AddToCartForm-${data.id}"
                    type="submit"
                    name="add"
                    class="quick-add__submit btn btn--full product-form__cart-submit `; 
                    if(! data.available ) {
                      html +=  `quick-add_soldout"`;
                    }
                    html += `aria-haspopup="dialog"
                    aria-labelledby="AddToCartForm-${data.id}"
                    aria-live="polite"
                    aria-disabled="false"
                    data-sold-out-message="true"`;
                    if(! data.available ) {
                    html +=  `disabled`;
                    }
                    html += `>
                    <span>`;
                    if( data.available ) {
                   html += `<svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_1057:650)">
                        <path d="M7 20.0625C7.82843 20.0625 8.5 19.3909 8.5 18.5625C8.5 17.7341 7.82843 17.0625 7 17.0625C6.17157 17.0625 5.5 17.7341 5.5 18.5625C5.5 19.3909 6.17157 20.0625 7 20.0625Z" fill="black"></path>
                        <path d="M16.625 20.0625C17.4534 20.0625 18.125 19.3909 18.125 18.5625C18.125 17.7341 17.4534 17.0625 16.625 17.0625C15.7966 17.0625 15.125 17.7341 15.125 18.5625C15.125 19.3909 15.7966 20.0625 16.625 20.0625Z" fill="black"></path>
                        <path d="M2.75006 1.2125H2.75H0H-0.1V1.3125V2.625V2.725H0H2.10503L4.72837 15.2429C4.72837 15.2429 4.72837 15.2429 4.72838 15.2429C4.76449 15.4153 4.86186 15.5695 5.0027 15.6798C5.14346 15.7901 5.31918 15.8499 5.49994 15.85H5.5H17.875H17.975V15.75V14.4375V14.3375H17.875H6.14497L5.63687 11.9125H17.875C18.053 11.9125 18.2261 11.8546 18.3659 11.7475C18.5057 11.6404 18.604 11.4903 18.6434 11.3213L18.6434 11.3213L20.2026 4.6164L20.2312 4.49375H20.1052H18.6979H18.6185L18.6005 4.57109L17.2442 10.4H5.31996L3.52163 1.81963C3.52163 1.81962 3.52162 1.81962 3.52162 1.81961C3.48551 1.64717 3.38814 1.49296 3.2473 1.38266C3.10654 1.27243 2.93082 1.2126 2.75006 1.2125Z" fill="black" stroke="black" stroke-width="0.2"></path>
                        </g>
                        <defs>
                        <clipPath id="clip0_1057:650">
                        <rect width="22" height="21" fill="white"></rect>
                        </clipPath>
                        </defs>
                        </svg>`;          
                 } else {
                   html += `Sold out`;
                 } 
               html +=    `</span>`;
                    if( data.available ) {
                   html += `<div class="loading-overlay__spinner hidden">
                       <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                       </svg>
                    </div>`;
                    }
                 html +=   `</button>
                    </div>
                  </form>`; 
    
    return html;
  }

  function buildColorSwatches(data) {

    var html = '';
    for (var i = 0; i < (data.options_with_values).length; i++) {
      if(data.options_with_values[i].label != "Default") {
        html = `  <div class="boost-pfs-quickview-selector-wrapper" id="ProductId-${ data.id }-ProductSelect-option-${ i }" name="${ data.options_with_values[i].label }">`;
        html += `<ul class="collection-page-swatch">`;
                    for (var j = 0; j < (data.options_with_values[i].values).length; j++) { 
                    var str = (data.options_with_values[i].values[j].title).toLowerCase(); var url_path = "";
                    var result1 = str.replaceAll(' ', '-');
                    result1 = result1.replaceAll('/', '-');
                    var dataVariant  = data.variants[j].id;
                    var dataImage    = data.variants[j].image;
                    var dataVariantPrice = data.variants[j].price;    
                    var checkedSwatch = "";
                    if(j==0){
                      checkedSwatch = "checkedSwatch";
                    }
                    if(result1 == "rose-gold") {
                      var url_path = "//cdn.shopify.com/s/files/1/2462/4651/t/20/assets/"+result1+'.png';
                    }else{
                      var url_path = "//cdn.shopify.com/s/files/1/2462/4651/files/"+result1+'.png';
                    }
                    html += `<li data-image_name="" class='collection-swatch-li ${ checkedSwatch }' data-variant_image=${ dataImage } data-variant_price=${ dataVariantPrice } data-variant-id=${ dataVariant } data-product-handle="product-b" style="background-color:${ result1 };background-image:url(${ url_path }) ">
                              <a data-variant_image='' href=''></a>
                              <span class="tooltipgd-text">${ data.options_with_values[i].values[j].title }</span>
                            </li>`;  
                    }
        html += `</ul></div>`;   
      }
    }
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }
    
  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.afterBindEvents = function() {
    // let temp = jQ(Selector.topSorting + ' .facet-filters__sort');
    let temp = jQ('#SortBy option');
    temp.on('click', function(e) {
      //console.log('clicked')
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
    try {
if (typeof iWish !== "undefined") {
iWish.checkIwishColl();
}
} catch (error) {
// console.log(error);
}
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    // Build Showing Items
    var from = 1;
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('?');

    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        //console.log(sParameterName)
        if (sParameterName[0] == "page") 
        {
            from = sParameterName[1].split('&')[0];
        }
    } 
    var page_limit = this.filterResult.pagination.settings.limit;
    //console.log(from)
    //console.log(page_limit)
    var fromItem = from == 1 ? from : (from - 1) * page_limit + 1; 
    var to = fromItem + data.products.length - 1;
    jQ('.boost-pfs-filter-bottom-pagination').find('.count').html('Showing items  ' + fromItem + '-' + to + ' ' +  'of' + ' ' + data.total_product);
    jQ('.boost-pfs-filter-total-product').html('Showing items  ' + fromItem + '-' + to + ' ' +  'of' + ' ' + data.total_product);
    //jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  /************************** END BUILD TOOLBAR **************************/
})();
